import { useState } from "react";
import { AxiosProgressEvent } from "axios";

type ProgressFn = (event: AxiosProgressEvent) => void;

export function useUploadProgress(): [number, (key: string) => ProgressFn] {
  const [progress, setProgress] = useState<Record<string, number>>({});

  const createUploadProgress = (key: string): ProgressFn => {
    return (event: AxiosProgressEvent) => {
      const { progress } = event;

      if (progress) {
        setProgress((prev) => ({ ...prev, [key]: progress }));
      }
    };
  };

  const totals = Object.values(progress);
  const currentProgress = totals.reduce((a, b) => a + b, 0);

  const overallProgress =
    totals.length > 0 ? (currentProgress / totals.length) * 100 : 0;

  return [overallProgress, createUploadProgress];
}
